var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{staticClass:"left-container"},[_c(_setup.Header),_c(_setup.List,{attrs:{"selected":_setup.props.selected,"roles":_setup.props.roles},on:{"selected-role-changed":function($event){return _setup.handleSelectedRoleChanged($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }